module.exports = __webpack_public_path__ + "img/pingan_bank.81eaff3f.png";